module.exports = __webpack_public_path__ + "static/clock-e58f04fc2c790a71b186555b2e67ec15.jpg";